// I destinatari di una connessione Pushover. Le chiavi già salvate arrivano con la sola coda
// («…abcd») e restano com'erano; quelle nuove PopTown le verifica con Pushover prima di salvare.
import { useState } from 'react';
import { ApiError, api } from '../../lib/api';
import type { PushRecipient, ToolGroup } from '../../lib/api';
import { Banner } from '../../components/Banner';
import { Button } from '../../components/Button';
import { Modal } from '../../components/Modal';
import { RecipientsEditor } from './ConnectForms';

export function RecipientsModal({ group, onClose }: { group: ToolGroup; onClose: () => void }) {
  const [people, setPeople] = useState<PushRecipient[]>(
    (group.recipients ?? []).map((r) => ({ name: r.name, key: r.key })),
  );
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const rows = people.filter((r) => r.name.trim() || r.key.trim());

  const save = async () => {
    setBusy(true);
    setError(null);
    try {
      await api.setRecipients(group.id, rows);
      onClose();
    } catch (e) {
      setError(e instanceof ApiError && e.detail ? e.detail : 'Non riesco a salvare.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      title={`Destinatari di ${group.name}`}
      width={560}
      onClose={onClose}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Annulla
          </Button>
          <Button
            variant="primary"
            loading={busy}
            disabled={!rows.length || rows.some((r) => !r.name.trim() || !r.key.trim())}
            onClick={() => void save()}
          >
            Salva
          </Button>
        </>
      }
    >
      <RecipientsEditor value={people} onChange={setPeople} />
      {error && <Banner kind="danger">{error}</Banner>}
    </Modal>
  );
}
